const DevelopmentBanner = () => {
  const isDevelopment = process.env.REACT_APP_API_PREFIX?.includes('devapi.bocreate-dev.co.uk') ?? false;

  // Don't render anything if not in development mode
  if (!isDevelopment) {
    return null;
  }

  return (
    <div
      style={{
        backgroundColor: '#dc3545',
        color: 'white',
        padding: '8px 0',
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: '14px',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      }}
    >
      DEVELOPMENT SYSTEM - NOT FOR PRODUCTION USE
    </div>
  );
};

export default DevelopmentBanner;
